// extracted by mini-css-extract-plugin
export default {"cardImg":"Card_cardImg__wDKHC","card":"Card_card__7Eml9","details":"Card_details__uDDfd"};